import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRef } from 'vue'

import FlightCompensationPopover from './FlightCompensationPopover.vue'
import LButton from '@/components/core/Button.vue'
import {
  useFlightStatus,
  useRegisterFlightAlert,
} from '@/composables/transportation'
import { useSelectedTrip } from '@/composables/trip'
import { eventModule } from '@/store'
import {
  FlightTransportationUIInput,
  isPersistedUITransportation,
} from '@/types/transportation'
import { formatTime } from '@/utils/date-utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'FlightStatus',
  props: {
    transportation: null
  },
  setup(__props: any) {

const props = __props as {
  transportation: FlightTransportationUIInput
};


const transportation = toRef(props, 'transportation')

const trip = useSelectedTrip()

const isRegistering = ref(false)

const { mutateAsync: registerFlightAlert } = useRegisterFlightAlert()

const shouldFetchFlightStatus = computed(() => {
  return (
    !!transportation.value.legacySystemId &&
    (!!transportation.value.flightUpdateRule ||
      transportation.value.preRegistered)
  )
})
const {
  data: flightStatus,
  refetch,
  isLoading,
} = useFlightStatus({
  tripId: trip.value.id,
  transportationId: transportation.value.legacySystemId,
  queryOptions: {
    retry: false,
    enabled: shouldFetchFlightStatus,
  },
})

const canRegisterAlert = computed(() => {
  return !!isPersistedUITransportation(transportation.value)
})

async function registerFlightAlerts() {
  if (!trip.value.activeProSubscription) {
    window.open(`${process.env.DASHBOARD_HOME}/pro/features`, '_blank')
    return
  }

  if (!transportation.value.legacySystemId) {
    return
  }
  isRegistering.value = true

  try {
    const response = await registerFlightAlert({
      tripId: trip.value.id,
      transportationId: transportation.value.legacySystemId,
    })

    if (response.success) {
      await refetch()
    } else if (response.missingFields) {
      eventModule.setValues({
        missingFields: response.missingFields.join(', '),
      })
      eventModule.newError('error.transportation.flightStatus.missingFields')
    }
  } finally {
    isRegistering.value = false
  }
}

// Indicates if the flight has any issues
const areFlightIssuesPresent = computed(() => {
  if (!flightStatus.value) {
    return false
  }

  return (
    flightStatus.value.status === 'CANCELED' ||
    flightStatus.value.status === 'DIVERTED' ||
    flightStatus.value.status === 'REDIRECTED' ||
    flightStatus.value.status === 'UNKNOWN' ||
    flightStatus.value.status === 'NOT_OPERATIONAL'
  )
})

return { __sfc: true,props, transportation, trip, isRegistering, registerFlightAlert, shouldFetchFlightStatus, flightStatus, refetch, isLoading, canRegisterAlert, registerFlightAlerts, areFlightIssuesPresent, FlightCompensationPopover, LButton, isPersistedUITransportation, formatTime }
}

})